/*
 * Next.js provides polyfills https://github.com/vercel/next.js/blob/canary/packages/next-polyfill-nomodule/src/index.js
 * but for better Developer Experience we provide more of them
 */
import 'core-js/features/array/to-reversed'
import 'core-js/features/array/to-sorted'
import 'core-js/features/error/is-error'
import 'core-js/features/global-this'
import 'core-js/features/iterator/find'
import 'core-js/features/iterator/map'
import 'core-js/features/iterator/to-array'
import 'core-js/features/map/get-or-insert-computed'
import 'core-js/features/set/symmetric-difference'
import 'core-js/features/string/at'
import 'core-js/features/string/replace-all'
import 'core-js/features/object/from-entries'
import 'core-js/features/url/can-parse'
import './web.crypto.randomUUID'
